import type {
  MapMarkersCollection,
  UseMapMarkersProps,
} from "./map-markers.type";
import type { OnAdvancedMarkerRenderProps } from "../map-marker";
import type { MapMarkerWithSiblings } from "../map.type";

import { useEffect, useMemo, useState } from "react";

export const useMapMarkers = ({ mapId, markers }: UseMapMarkersProps) => {
  const [collection, setCollection] = useState<MapMarkersCollection>({});
  const [activeMarker, setActiveMarker] =
    useState<MapMarkerWithSiblings | null>(null);

  const activeAdvancedMarker = useMemo(() => {
    return activeMarker ? collection[activeMarker.key] : null;
  }, [activeMarker, collection]);

  const advancedMarkers = useMemo(() => {
    return Object.values(collection).filter((element) => element !== null);
  }, [collection]);

  const onAdvancedMarkerRender = ({
    advancedMarker,
    marker,
  }: OnAdvancedMarkerRenderProps) => {
    if (!advancedMarker || collection[marker.key]) return;

    setCollection((state) => ({ ...state, [marker.key]: advancedMarker }));
  };

  useEffect(() => {
    setActiveMarker(null);
    setCollection({});
  }, [mapId, markers]);

  return {
    activeMarker,
    setActiveMarker,
    activeAdvancedMarker,
    advancedMarkers,
    onAdvancedMarkerRender,
  };
};
